if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.attachListeners();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      attachListeners() {
        const labels = document.querySelectorAll('label[for="property-custom-icon"]');
        labels.forEach(label => {
          label.addEventListener('click', () => {
            const fileInput = this.querySelector('#property-custom-icon');
    
            // Remove any existing 'change' event listener to avoid duplication
            fileInput.removeEventListener('change', this.handleFileInputChange);
        
            // Bind the current context (this) and the clicked label to the event handler
            this.handleFileInputChange = this.inputCustomIcon.bind(this, label, fileInput);

            // Add the 'change' event listener to the file input
            fileInput.addEventListener('change', this.handleFileInputChange);
          })
        })
      }

  inputCustomIcon(clickedLabel, fileInput) {
  // Check if we've already processed this event
  if (fileInput.dataset.processing === 'true') return;
  
  // Mark as processing
  fileInput.dataset.processing = 'true';
  
  // Validate that a proper file was selected
  if (!fileInput.files || fileInput.files.length === 0 || 
      !fileInput.files[0].type || !fileInput.files[0].type.match('image.*')) {
    
    // Reset file input
    fileInput.value = '';
    
    // Show error message
    const fileDisclaimer = clickedLabel.nextElementSibling;
    const labelAbbr = clickedLabel.querySelector('#label-abbr');
    const uploadLabel = clickedLabel.querySelector('#upload-label');
    
    if (fileDisclaimer) {
      fileDisclaimer.textContent = 'Invalid file. Please upload an image file.';
      fileDisclaimer.style.color = '#ff0000';
    }
    
    if (uploadLabel) {
      const originalLabelValue = uploadLabel.dataset.labelValue;
      uploadLabel.textContent = originalLabelValue;
      if (labelAbbr) labelAbbr.title = '';
    }
    
    // Reset processing flag
    setTimeout(() => {
      fileInput.dataset.processing = 'false';
    }, 100);
    
    return;
  }
  
  const fileName = fileInput.files[0].name;
  const fileDisclaimer = clickedLabel.nextElementSibling;
  const labelAbbr = clickedLabel.querySelector('#label-abbr');
  const uploadLabel = clickedLabel.querySelector('#upload-label');
// Add this BEFORE the for loop (around line 86):
const giftCardControlFields = [
  'properties[__shopify_send_gift_card_to_recipient]',
  'properties[__shopify_offset]'
];

// Then include them in your loop or handle separately:
giftCardControlFields.forEach(field => {
  if (formData.has(field)) {
    newFormData.append(field, formData.get(field));
  }
});

  if (fileName) {
    uploadLabel.textContent = fileName;
    labelAbbr.title = fileName;
    fileDisclaimer.textContent = 'File Uploaded Successfully';
    fileDisclaimer.style.fontWeight = 'bold';
    fileDisclaimer.style.color = ''; // Reset color if it was red
  } else {
    const originalLabelValue = uploadLabel.dataset.labelValue;
    uploadLabel.textContent = originalLabelValue;
    labelAbbr.title = '';
    fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
    fileDisclaimer.style.color = ''; // Reset color
  }
  
  // Reset processing flag after a short delay
  setTimeout(() => {
    fileInput.dataset.processing = 'false';
  }, 100);
}
      
      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const configCustom = fetchConfig('javascript');
        configCustom.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete configCustom.headers['Content-Type'];

        const formData = new FormData(this.form);
        const newFormData = new FormData();

        const keysToDelete = [];

        
        // for (const [key, value] of formData.entries()) {
        //   const actualKey = key.toString();
        //   const keepKeys = ['properties[uniqueId]', 'properties[mainProduct]'];

        //   if (actualKey.startsWith('properties') && !keepKeys.includes(actualKey) || (keepKeys.includes(actualKey) && !value) ) {
        //     newFormData.append(actualKey, value);
        //     keysToDelete.push(actualKey);
        //   }
        // }
      for (const [key, value] of formData.entries()) {
  const actualKey = key.toString();
  const keepKeys = [
    'properties[uniqueId]', 
    'properties[mainProduct]',
    'properties[Recipient email]',
    'properties[Recipient name]', 
    'properties[Message]',
    'properties[Send on]',
    'properties[__shopify_send_gift_card_to_recipient]',
    'properties[__shopify_offset]'
  ];

if (actualKey.startsWith('properties') && !keepKeys.includes(actualKey) || (keepKeys.includes(actualKey) && !value) ) {
    // NEW: skip empty-value properties so they never reach the cart line item
    if (actualKey.startsWith('properties[') && !value) {
      keysToDelete.push(actualKey);
      continue;
    }
    newFormData.append(actualKey, value);
    keysToDelete.push(actualKey);
  }
}

        for (const key of keysToDelete) {
          formData.delete(key);
        }

        // Change from localStorage to getCookie
        const bundleBody = getCookie('bundleBody');

        if (bundleBody) {
          const newFormObj = bundleBody;
          const firstItem = newFormObj.items[0];
          newFormData.append('id', firstItem.id);
          const properties = firstItem.properties;
          newFormData.append('properties[mainProductId]', properties.mainProductId);
          newFormData.append('properties[uniqueSubId]', properties.uniqueSubId);
        }

        // Change from localStorage to getCookie and localStorage for custom icon
        const formDataStorage = localStorage.getItem('formData') ? JSON.parse(localStorage.getItem('formData')) : getCookie('formData');

        if (formDataStorage) {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            newFormData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            newFormData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;
          configCustom.body = newFormData;

          this.addProductsToCart(formData, config, configCustom, newFormData);
        }
        else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

    async addProductsToCart(formData, config, configCustom, newFormData) {
  try {
    // First fetch call
    let response = await fetch("/cart/add", config);
    response = await response.json();
    if (response.status) {
      // Replace alert with error handling similar to what you're doing elsewhere
      this.handleErrorMessage(response.description || "Problem while adding main product to cart");
      // this.error = true;
    } else {
      // Second fetch call
      let bundleResponse = await fetch(`${routes.cart_add_url}`, configCustom)
      bundleResponse = await bundleResponse.json();
      if (bundleResponse.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: bundleResponse.errors || bundleResponse.description,
          message: bundleResponse.message,
        });
        this.handleErrorMessage(bundleResponse.description);
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }
        this.error = true;
      } else {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: bundleResponse,
          });
        }
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(bundleResponse);
              // Modify removal of storage
              removeCookie('formData');
              removeCookie('bundleBody');
              localStorage.removeItem('formData');
              checkLocalStorage();
              removeAllInputs();
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(bundleResponse);
          // Modify removal of storage
          removeCookie('formData');
          removeCookie('bundleBody');
          localStorage.removeItem('formData');
          checkLocalStorage();
          removeAllInputs();
          newFormData = new FormData();
        }
      }
    }
  } catch (error) {
    console.error(error);
    this.handleErrorMessage("An unexpected error occurred. Please try again.");
  } finally {
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) {
      this.cart.classList.remove('is-empty');
    }
    if (!this.error) {
      this.submitButton.removeAttribute('aria-disabled');
    }
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    // Modify removal of storage
    removeCookie('formData');
    removeCookie('bundleBody');
    localStorage.removeItem('formData');
    checkLocalStorage();
    removeAllInputs();
    newFormData = new FormData();
  }
}
    }
  );

}